export default __webpack_public_path__ + "static/media/search.cb37e5e0.svg";